import { render, staticRenderFns } from "./Editorr.vue?vue&type=template&id=acd7e89c&scoped=true&"
import script from "./Editorr.vue?vue&type=script&lang=js&"
export * from "./Editorr.vue?vue&type=script&lang=js&"
import style0 from "./Editorr.vue?vue&type=style&index=0&id=acd7e89c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd7e89c",
  null
  
)

export default component.exports